import { render } from "./VPerPage.vue?vue&type=template&id=221e9fa3&scoped=true"
import script from "./VPerPage.vue?vue&type=script&lang=js"
export * from "./VPerPage.vue?vue&type=script&lang=js"

import "./VPerPage.vue?vue&type=style&index=0&id=221e9fa3&lang=scss&scoped=true"

import exportComponent from "/Users/sherinbloemendaal/projects/spb/pricetiger/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-221e9fa3"]])

export default __exports__